export default "__VITE_ASSET__b921ecba__"